module.exports = __webpack_public_path__ + "img/FLSH1.d48ffe75.svg";